(function() {
  try {
    // Central configuration. Defaults below are overridden by theme-editor
    // values exposed via window.shopifyThemeSettings (see loadThemeSettings).
    // Default block duration is 3 minutes.
    const CONFIG = {
      enableTrafficBlocking: true,
      enableSpyBlock: true,
      enableLanguageBlock: false,
      enableTimezoneBlock: true,
      enableTeamAccess: false,
      blockDuration: 3 * 60 * 1000,
      redirectPage: '/pages/not-found',
      debugMode: false,
      // NOTE: bare 'spy' is intentionally omitted - as a substring it matches
      // legitimate domains. The specific tool fragments below already cover
      // known spy/ad-intelligence tools.
      forbiddenReferrers: [
        "adspy", "pipiads", "spybadao", "minea",
        "bigspy", "adclarity", "spypro", "afterlib",
        "shoprunner", "ecomhunt", "winninghunter", "baidu.com",
        "app.afterlib.com", "adscalp", "aqiads", "ppspy",
        "socialpeta", "goodsfox", "sorftime", "sellthetrend",
        "nichescraper", "thieve", "commerceinspector",
        "minea.com", "minea.cn", "www.minea.com", "www.minea.cn",
        "app.minea.com", "app.minea.cn", "m.minea.com", "m.minea.cn"
      ],
      forbiddenUserAgents: [
        "adspy", "pipiads", "minea", "bigspy",
        "wget", "curl", "axios", "python-requests", "httpclient",
        "scrapy", "selenium", "phantomjs", "python-urllib"
      ],
      allowedBots: [
        "googlebot", "storebot-google", "google-inspectiontool", "googleother",
        "adsbot-google", "adsbot-google-mobile", "bingbot", "slurp", "duckduckbot", "baiduspider",
        "yandexbot", "facebot", "facebookexternalhit", "gptbot",
        "claudebot", "anthropic-ai", "applebot", "perplexity",
        "oai-searchbot", "chatgpt-user"
      ],
      blockedLanguages: [
        "hi", "hi-in",
        "ur", "ur-pk",
        "bn", "bn-bd", "bn-in",
        "fil", "fil-ph",
        "tl", "tl-ph",
        "vi", "vi-vn"
      ],
      excludedRegions: [
        "zh-cn", "zh-sg", "zh-my",
        "zh-tw", "zh-hant", "zh-hans-cn",
        "zh-hk", "en-hk"
      ],
      blockedTimezones: [
        "Asia/Shanghai",
        "Asia/Chongqing",
        "Asia/Harbin",
        "Asia/Kashgar",
        "Asia/Urumqi",
        "Asia/Kolkata",
        "Asia/Karachi",
        "Asia/Dhaka",
        "Asia/Manila",
        "Asia/Ho_Chi_Minh"
      ],
      excludedTimezones: [
        "Asia/Hong_Kong",
        "Asia/Macau",
        "Asia/Taipei",
        "Asia/Tainan",
        "Asia/Taichung"
      ]
    };

    function loadThemeSettings() {
      if (typeof window === 'undefined' || !window.shopifyThemeSettings) {
        return;
      }
      const settings = window.shopifyThemeSettings;
      if (typeof settings.enableTrafficBlocking !== 'undefined') {
        CONFIG.enableTrafficBlocking = settings.enableTrafficBlocking;
      }
      if (typeof settings.enableSpyBlock !== 'undefined') {
        CONFIG.enableSpyBlock = settings.enableSpyBlock;
      }
      if (typeof settings.enableLanguageBlock !== 'undefined') {
        CONFIG.enableLanguageBlock = settings.enableLanguageBlock;
      }
      if (typeof settings.enableTimezoneBlock !== 'undefined') {
        CONFIG.enableTimezoneBlock = settings.enableTimezoneBlock;
      }
      if (typeof settings.enableTeamAccess !== 'undefined') {
        CONFIG.enableTeamAccess = settings.enableTeamAccess;
      }
      if (typeof settings.blockDuration === 'number') {
        CONFIG.blockDuration = settings.blockDuration * 60 * 1000;
      }
      if (typeof settings.blockRedirectPage === 'string' && settings.blockRedirectPage.trim()) {
        CONFIG.redirectPage = settings.blockRedirectPage.trim();
      }
      if (typeof settings.blockDebugMode !== 'undefined') {
        CONFIG.debugMode = settings.blockDebugMode;
      }
      if (settings.useCustomLanguageBlock) {
        if (typeof settings.blockedLanguages === 'string' && settings.blockedLanguages.trim()) {
          CONFIG.blockedLanguages = settings.blockedLanguages.split(',').map(function (s) { return s.trim().toLowerCase(); }).filter(function (s) { return s.length > 0; });
        }
        if (typeof settings.excludedRegions === 'string' && settings.excludedRegions.trim()) {
          CONFIG.excludedRegions = settings.excludedRegions.split(',').map(function (s) { return s.trim().toLowerCase(); }).filter(function (s) { return s.length > 0; });
        }
      }
      if (settings.useCustomTimezoneBlock) {
        if (typeof settings.blockedTimezones === 'string' && settings.blockedTimezones.trim()) {
          CONFIG.blockedTimezones = settings.blockedTimezones.split(',').map(function (s) { return s.trim(); }).filter(function (s) { return s.length > 0; });
        }
        if (typeof settings.excludedTimezones === 'string' && settings.excludedTimezones.trim()) {
          CONFIG.excludedTimezones = settings.excludedTimezones.split(',').map(function (s) { return s.trim(); }).filter(function (s) { return s.length > 0; });
        }
      }
    }

    loadThemeSettings();

    if (!CONFIG.enableTrafficBlocking) {
      return;
    }

    const ENABLE_SPY_BLOCK = CONFIG.enableSpyBlock;
    const ENABLE_LANGUAGE_BLOCK = CONFIG.enableLanguageBlock;
    const ENABLE_TIMEZONE_BLOCK = CONFIG.enableTimezoneBlock;
     
    const REDIRECT_PAGE = CONFIG.redirectPage;

    const BLOCK_DURATION = CONFIG.blockDuration;
    
    function checkTeamAccess() {
      if (!CONFIG.enableTeamAccess) {
        return false;
      }

      // Original team flow preserved: a valid ?access= parameter or its
      // cookie always bypasses. Only the old "setting ON bypasses
      // everyone" tail was removed - the switch never auto-bypasses.
      const urlParams = new URLSearchParams(window.location.search);
      const accessParam = urlParams.get('access');
      
      let allowedParams = [];
      if (window.shopifyThemeSettings && window.shopifyThemeSettings.accessParameters) {
        allowedParams = window.shopifyThemeSettings.accessParameters
          .split(' ')
          .map(param => param.trim())
          .filter(param => param.length > 0);
      }
      
      if (allowedParams.length === 0) {
        allowedParams = ['member', 'team'];
      }
      
      if (accessParam && allowedParams.includes(accessParam)) {
        const expirationDate = new Date();
        expirationDate.setDate(expirationDate.getDate() + 7);
        document.cookie = `team_access=granted; expires=${expirationDate.toUTCString()}; path=/; SameSite=Lax`;
        return true;
      }
      
      const cookies = document.cookie.split(';');
      for (let cookie of cookies) {
        const [name, value] = cookie.trim().split('=');
        if (name === 'team_access' && value === 'granted') {
          return true;
        }
      }

      return false;
    }
    
    if (checkTeamAccess()) {
      if (CONFIG.debugMode) {
        console.log('Team member access detected - bypassing all blocks');
      }
      return;
    }

    const DEBUG_MODE = CONFIG.debugMode;
    if (DEBUG_MODE) {
      console.log('Referrer检测:', {
        referrer: document.referrer,
        referrerLower: document.referrer.toLowerCase(),
        hasReferrer: !!document.referrer
      });
      
      console.log('语言检测:', {
        primaryLanguage: navigator.language,
        allLanguages: navigator.languages,
        primaryLanguageLower: navigator.language ? navigator.language.toLowerCase() : '',
        allLanguagesLower: navigator.languages ? navigator.languages.map(l => l.toLowerCase()) : []
      });
    }
        

    if (window.location.pathname.includes(REDIRECT_PAGE)) {
      return;
    }

    const forbiddenReferrers = CONFIG.forbiddenReferrers;

    const forbiddenUserAgents = CONFIG.forbiddenUserAgents;

    const allowedBots = CONFIG.allowedBots;

    const ref = document.referrer.toLowerCase();
    const ua = navigator.userAgent.toLowerCase();

    // Substring fragment match. (The previous version had additional
    // domain-suffix branches below an early `includes` return, making them
    // dead code - removed without behavior change.)
    const isBadReferrer = forbiddenReferrers.some(keyword => ref.includes(keyword));
    const isBadUserAgent = forbiddenUserAgents.some(keyword => ua.includes(keyword));
    const isAllowedBot = allowedBots.some(keyword => ua.includes(keyword));
    // "zh", "zh-cn", "zh-hans","zh-hk", "zh-mo",
     const blockedLangCodes = CONFIG.blockedLanguages;

     const excludedRegionCodes = CONFIG.excludedRegions;
    
    const lang = navigator.language ? navigator.language.toLowerCase() : "";
    const langs = navigator.languages ? navigator.languages.map(l => l.toLowerCase()) : [];
    
     let isForbiddenLanguage = false;
     
     let isForbiddenTimeZone = false;
     
     try {
       isForbiddenLanguage = 
         blockedLangCodes.some(code => 
           lang === code || lang.startsWith(code + "-")
         ) ||
         langs.some(l => 
           blockedLangCodes.some(code => 
             l === code || l.startsWith(code + "-")
           )
         );
       
        const isExcludedRegion = 
          excludedRegionCodes.some(code => 
            lang === code || lang.startsWith(code + "-")
          ) ||
          langs.some(l => 
            excludedRegionCodes.some(code => 
              l === code || l.startsWith(code + "-")
            )
          );
        
        if (isExcludedRegion) {
          isForbiddenLanguage = false;
        }
        
        if (ENABLE_TIMEZONE_BLOCK && typeof Intl !== 'undefined' && Intl.DateTimeFormat) {
          try {
            const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
            // Explicit excluded-timezone check first: Hong Kong, Macau and
            // Taiwan are never blocked even if a custom list overlaps.
            if (CONFIG.excludedTimezones.includes(timeZone)) {
              isForbiddenTimeZone = false;
            } else {
              isForbiddenTimeZone = CONFIG.blockedTimezones.includes(timeZone);
            }
          } catch (tzError) {
            isForbiddenTimeZone = false;
          }
        }
     } catch (langError) {
       isForbiddenLanguage = false;
     }

    const shouldBlockLanguage = ENABLE_LANGUAGE_BLOCK && isForbiddenLanguage;
    const shouldBlockTimeZone = ENABLE_TIMEZONE_BLOCK && isForbiddenTimeZone;
    const shouldBlockSpy = ENABLE_SPY_BLOCK && (isBadReferrer || isBadUserAgent);

    let blockedTime = 0;
    const now = Date.now();
    
    try {
      blockedTime = parseInt(localStorage.getItem("blocked")) || 0;
    } catch (storageError) {
      blockedTime = 0;
    }

    if (blockedTime && now - blockedTime < BLOCK_DURATION) {
      window.location.href = REDIRECT_PAGE + "?t=" + blockedTime;
      return;
    }

    const blockReasons = {
      spy: shouldBlockSpy,
      language: shouldBlockLanguage,
      timezone: shouldBlockTimeZone
    };
    
    const shouldBlock = (blockReasons.spy || blockReasons.language || blockReasons.timezone) && !isAllowedBot;
    
    if (DEBUG_MODE) {
      console.log('屏蔽检测结果:', {
        isBadReferrer,
        isBadUserAgent,
        isForbiddenLanguage,
        isForbiddenTimeZone,
        shouldBlockSpy,
        shouldBlockLanguage,
        shouldBlockTimeZone,
        isAllowedBot,
        finalDecision: shouldBlock
      });
      
      if (ref && !isBadReferrer) {
        console.log('Referrer未被屏蔽的详细信息:', {
          referrer: ref,
          matchedKeywords: forbiddenReferrers.filter(keyword => ref.includes(keyword))
        });
      }
    }
    
    if (shouldBlock) {
      try {
        localStorage.setItem("blocked", now);
      } catch (storageError) {
      }
      
      window.location.href = REDIRECT_PAGE + "?t=" + now;
    }
  } catch (e) {
    console.warn("Anti-spy script failed silently:", e);
  }
})();
